<script lang="ts">
  import { getContext } from "svelte";
  import { ethereum } from "../../store/ethereum";

  import Connect from "../ethereum/Connect.svelte";
  import ReferralModal from "../modals/ReferralModal.svelte";
  import TopBar from "../TopBar.svelte";
  import Menu from "./Menu.svelte";

  const { open } = getContext("simple-modal");
  const showReferrals = () => {
    open(ReferralModal, { address: $ethereum.address });
  };
    
  let isOpen = false;
  let hidden = true;

  const toggle = () => {
    isOpen = !isOpen;
    hidden = !isOpen;
  };

  const CloseMenu = () => {
    isOpen = false;
  }
    
</script>


<nav class="navbar navbar-expand-lg myNav">
  <div class="container">
    <a on:click={CloseMenu} class="navbar-brand" href="/"><img src="/img/logo.png" alt="logo" /><span class="nav-link">Dogs of Elon</span></a>
    <button class="navbar-toggler" type="button" on:click={toggle} class:isOpen>
      <i class="fas fa-times close" />
      <i class="fas fa-bars open" />
    </button>
    <div class="collapse navbar-collapse" class:isOpen>
      <ul class="navbar-nav m-auto my-2 my-lg-0">
        <li class="nav-item">
          <a  on:click={CloseMenu} class="nav-link" href="/#Governance">Governance</a>
        </li>
        <li class="nav-item">
          <a on:click={CloseMenu} class="nav-link" href="/#buy">Buy</a>
        </li>
        <li class="nav-item">
          <a on:click={CloseMenu} class="nav-link" href="/#nft">NFT</a>
        </li>
        <li class="nav-item">
          <a on:click={CloseMenu} class="nav-link" href="/#gaming">Gaming</a>
        </li>
        <li class="nav-item">
          <a on:click={CloseMenu} class="nav-link" href="/staking">Staking</a>
        </li>        
        <li class="nav-item">
          <a on:click={CloseMenu} class="nav-link" href="/about">About Us</a>
        </li>
      </ul>
      <div class="justify-content-end navbar-nav">
        <!-- <button class="leg_btn"><img src="img/images/world.svg" alt="icon"/>ENG</button>        -->
        <Connect />
      </div>
    </div>
  </div>
</nav>

<style>

.myNav{
  background: #212335;
  padding:40px 10px;
}
.myNav .navbar-brand{
  color: #fff;
  font-size: 16px;   
  display: flex;
  align-items: center;
  font-weight: 700;
  min-width: 250px;
}
.myNav .navbar-brand img{
  height:40px;
}
.myNav .navbar-brand:hover
{
  color: #fff;
}
.myNav .navbar-brand:focus{
  color: #fff;
}
.myNav .navbar-nav .nav-link{
  color: #fff !important;
  font-size: 18px;
  margin-left: 10px;
  margin-right: 10px;
}
.myNav .navbar-nav .nav-link:focus{
  color: #fff;
}
.myNav .navbar-nav .nav-link:hover{
  color: #fff;
}
.myNav .leg_btn{
  background-color: #232539;
  font-size: 18px;
  text-transform: uppercase;
  padding: 0 10px;
  border: none;
  color: #fff;
  height: 38px;
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.myNav .leg_btn img{
  margin-right: 5px;
}
.myNav .connect_btn{
  background-color: #93cdbf;
  color: #212336;
  padding: 10px 50px;
  border: none;
  height: 38px;
  font-size: 11px;  
  font-weight: 600;
  text-decoration: none;
}
.myNav .connect_btn:hover{
  background-color: #ffa853;
}
.navbar-toggler-icon{
  background-image: url(../../assets/images/images/menu.svg) !important;
}
.navbar-toggler{
  box-shadow: none !important;
  border: none;
}
.navbar-nav-scroll{
  max-height: auto !important;
}
@media (max-width: 1300px){
  .myNav {
      padding: 25px 10px;
  }
}
@media (max-width:1200px){
  
  .myNav .connect_btn{
    padding: 9px 30px;
  }
  .myNav .navbar-nav .nav-link{
    margin-right: 10px;
    margin-left: 10px;
  }
  .myNav .navbar-brand {
    min-width: 150px;
  }
}
@media (max-width:992px){
  .collapse.isOpen{
    display:block;
  }
  .navbar-toggler{
    color:#fff;
    font-size:24px;
  }
  .navbar-toggler .close{
    display:none;
  }
  .navbar-toggler.isOpen .close{
    display:block;
  }
  .navbar-toggler.isOpen .open{
    display:none;
  }
  .myNav {
    padding: 10px 5px;
  }
  .myNav .leg_btn{
    width: 80px;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .myNav .connect_btn{
    width: 200px;
  }
}
@media (max-width:768px){
  .myNav {
    padding: 0;
  }
 
}
</style>
